angular.module("razor_views")

    .controller('RazorViewsEditCtrl', ['$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', '$translate', 'modalService','$filter','Upload', function ($rootScope, $scope, $http, $stateParams, Restangular, $state, $translate, modalService, $filter, Upload) {

        $rootScope.title = $filter('translate')('razor_views.title');

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('razor_views.list'), url: "razor_views.list" },
                { title: $filter('translate')('razor_views.button_add') }
            ];
            $scope.razor_views = {
                created_at: new Date()
            };
        }
        else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('razor_views.list'), url: "razor_views.list" },
                { title: $filter('translate')('razor_views.edit') }
            ];
            Restangular.one('RazorViews', $stateParams.id).get().then(function (results) {
                $scope.razor_views = results;

            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }

        $scope.cancel = function () {
            $state.go("razor_views.list", { "reset": false });
        };

        $scope.save = function () {
            if (angular.isUndefined($stateParams.id) || $stateParams.id === "")
                Restangular.all('RazorViews').post($scope.razor_views).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('razor_views.success'));
                        $state.go("razor_views.edit");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            else {
                $scope.razor_views.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('razor_views.success'));
                        $state.go("razor_views.edit");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };
    }]);
